"use client";

import {
  CommunityType,
  useRequestAdminDashboardMember,
  useRequestCommunitiesAdminCommunity,
} from "@packages/sdk";
import { useModal } from "@packages/ui";
import { useEffect } from "react";

import { useAdminDashMemberActions } from "../../../lib/hooks/useAdminDashMemberActions";
import { useRequestCommunityAdminMembersDelete } from "../../../requests/useRequestCommunityAdminMembersDelete";
import { useRequestCommunityAdminRosterMembersDelete } from "../../../requests/useRequestCommunityAdminRosterMembersDelete";
import { MemberModal } from "./MemberModal";

type MemberModalViewProps = {
  communityId: number;
  memberId: number;
  isOnlyAdmin?: boolean;
  onClose?: () => void;
};
export const MemberModalView = ({
  communityId,
  memberId,
  isOnlyAdmin = false,
  onClose,
}: MemberModalViewProps) => {
  const modal = useModal(MemberModal);
  const { query: communityQuery } = useRequestCommunitiesAdminCommunity({
    id: communityId,
  });
  const deleteUserGeneral = useRequestCommunityAdminMembersDelete({
    id: communityId,
  });
  const deleteUserRoster = useRequestCommunityAdminRosterMembersDelete({
    id: communityId,
  });
  const { query: communityUserQuery, mutationPut: editUser } =
    useRequestAdminDashboardMember({
      userId: memberId,
      communityId,
    });
  const { handleRemoveFromGroup, handleChangeAdminRights } =
    useAdminDashMemberActions({
      communityId,
      user: communityUserQuery.data
        ? { ...communityUserQuery.data, is_only_admin: isOnlyAdmin }
        : communityUserQuery.data,
    });

  useEffect(() => {
    if (communityUserQuery.data && !modal.visible) {
      modal.show({
        communityType: communityQuery.data?.type,
        onAdminChange: () => {
          handleChangeAdminRights();
          modal.resolve();
          modal.remove();
          onClose?.();
        },
        onClose,
        onDelete: async () => {
          const deleteUser =
            communityQuery.data?.type === CommunityType.school
              ? deleteUserRoster
              : deleteUserGeneral;
          await deleteUser.mutateAsync({
            body: { user_ids: [memberId] },
            params: {
              path: { community_id: communityId },
            },
          });
          modal.resolve();
          modal.remove();
          onClose?.();
        },
        onRemove: () => {
          handleRemoveFromGroup();
          modal.resolve();
          modal.remove();
          onClose?.();
        },
        onSubmit: async (values) => {
          await editUser.mutateAsync({
            body: values,
            params: {
              path: { community_id: communityId, user_id: memberId },
            },
          });
          onClose?.();
        },
        user: communityUserQuery.data,
      });
    }
  }, [communityUserQuery.data]);

  return null;
};
